import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Checkbox,
  Tag,
  Tooltip,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  ErrorItem,
} from "../../../../Components/Items";
import round2Decimals from "../../../../Components/round2Decimals";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import VerReposicionCajaChica from "../VerReposicionCajaChica/VerReposicionCajaChica";
import {
  BankOutlined,
  CalculatorOutlined,
  FilterOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";

const { Option } = Select;
moment.locale("es");

class ReponerCajaChica extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    facturasCajaChica: undefined,
    todasBancos: null,
    objetoBancos: null,
    todasProyectos: null,
    objetoProyectos: null,
    objetoCajaChicaDestino: null,
    saldoActualCaja: 0,
    id: this.props.location.state.id,
    modoSaldar: !!this.props.location.state.modoSaldar,
    modalVerReposicion: false,
    modalVerReposicionId: null,
    //Filtros de la tabla de facturas. Viven aqui y NO en el Form porque `onFinish`
    //manda `{...values}` al backend: un FormItem de filtro viajaria en el body.
    filtroProveedores: [],
    filtroFormasDePago: [],
    filtroMetodosPago: [],
  };

  //Centinela para los renglones sin forma o sin metodo de pago, para que se puedan
  //filtrar igual que los que si lo traen.
  static SIN_DATO = "__sinDato__";

  componentDidMount() {
    this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.banco}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/selectFacturasCaja",
        { empresaId: this.props.empresaId, cajaId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontraron facturas para reponer");
        } else {
          let nuevasFacturas = res.data.map((value) => ({
            ...value,
            proyectoNombre: value.proyecto.nombre,
            proveedorNombre: value.proveedor
              ? value.proveedor.persona
                ? value.proveedor.razonSocial
                : `${value.proveedor.nombre} ${value.proveedor.apellidoPaterno} ${value.proveedor.apellidoMaterno}`
              : "",
            proveedorId: value.proveedorId ? value.proveedorId.toString() : null,
            formaDePagoId: value.formaDePagoId
              ? value.formaDePagoId.toString()
              : null,
            formaDePagoTexto: value.formaDePago
              ? `${value.formaDePago.c_FormaPago} - ${value.formaDePago.descripcion}`
              : "",
            metodoPago: value.metodoPago,
            saldoPendiente:
              value.totalPagar * value.tipoDeCambio -
              value.totalPagadoCajaChica * value.tipoDeCambio,
          }));
          this.setState({ facturasCajaChica: nuevasFacturas });
          this.formRef.current.setFieldsValue({ facturas: nuevasFacturas });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          const cajaActual = res.data.find(
            (value) => value._id.toString() === this.state.id.toString()
          );
          this.setState({
            saldoActualCaja: cajaActual ? cajaActual.saldo : 0,
            objetoCajaChicaDestino: res.data
              .filter((value) => value._id.toString() !== this.state.id.toString())
              .map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
          });
        }
      });
    this.setState({ loading: false });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    let cantidadPagarTotal = 0;
    values.facturas.forEach((value) => {
      cantidadPagarTotal += value.cantidadPagar ? value.cantidadPagar : 0;
    });
    const tieneTraspaso = !!values.traspasoCajaDestinoId && values.traspasoMonto > 0;
    if (cantidadPagarTotal === 0 && !tieneTraspaso)
      return message.info("Se necesitan cantidades para poder hacer esta operación");
    const saldar = this.state.modoSaldar;
    this.setState({ loading: true });
    axios
      .post(
        "cajaefectivo/reponerCaja",
        {
          ...values,
          empresaId: this.props.empresaId,
          cajaId: this.state.id,
          cantidadPagarTotal,
          saldar,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha recibido un pago");
          NotificacionPolizas(res.data.polizasId);
          this.formRef.current.resetFields();
          this.setState({
            modalVerReposicion: true,
            modalVerReposicionId: res.data.reposicionId,
          });
        } else if (res.data.success === 1) {
          message.error("No se puede recibir el pago");
        } else {
          message.error("Hubo un error y no se recibio el pago");
        }
      });
  }

  atras() {
    this.props.history.goBack();
  }

  llenarSaldoRestante() {
    const facturas = this.formRef.current.getFieldValue("facturas") || [];
    let totalAReponer = 0;
    facturas.forEach((value) => {
      totalAReponer += value.cantidadPagar ? value.cantidadPagar : 0;
    });
    const totalSumado = this.state.modoSaldar
      ? this.state.saldoActualCaja
      : this.state.saldoActualCaja + totalAReponer;
    this.formRef.current.setFieldsValue({
      traspasoMonto: Math.abs(round2Decimals(totalSumado)),
    });
  }

  textoMetodoPago(metodoPago) {
    if (metodoPago === 1) return "PUE";
    if (metodoPago === 2) return "PPD";
    return "";
  }

  hayFiltroActivo() {
    const { filtroProveedores, filtroFormasDePago, filtroMetodosPago } =
      this.state;
    return (
      filtroProveedores.length > 0 ||
      filtroFormasDePago.length > 0 ||
      filtroMetodosPago.length > 0
    );
  }

  //Un filtro vacio no filtra; los tres se combinan con AND.
  pasaFiltro(factura) {
    if (!factura) return false;
    const { filtroProveedores, filtroFormasDePago, filtroMetodosPago } =
      this.state;
    const SIN_DATO = ReponerCajaChica.SIN_DATO;

    if (
      filtroProveedores.length > 0 &&
      !filtroProveedores.includes(factura.proveedorId || SIN_DATO)
    )
      return false;

    if (
      filtroFormasDePago.length > 0 &&
      !filtroFormasDePago.includes(factura.formaDePagoId || SIN_DATO)
    )
      return false;

    if (
      filtroMetodosPago.length > 0 &&
      !filtroMetodosPago.includes(
        factura.metodoPago ? String(factura.metodoPago) : SIN_DATO
      )
    )
      return false;

    return true;
  }

  //Las opciones salen de las facturas que de hecho estan pendientes en esta caja
  //y no del catalogo completo: asi no hay peticiones extra ni opciones que no
  //filtren nada. El centinela de "sin dato" siempre queda al final.
  opcionesFiltros() {
    const SIN_DATO = ReponerCajaChica.SIN_DATO;
    const proveedores = new Map();
    const formasDePago = new Map();
    const metodosPago = new Map();

    (this.state.facturasCajaChica || []).forEach((factura) => {
      proveedores.set(
        factura.proveedorId || SIN_DATO,
        factura.proveedorId
          ? factura.proveedorNombre || "Sin nombre"
          : "Sin proveedor"
      );
      formasDePago.set(
        factura.formaDePagoId || SIN_DATO,
        factura.formaDePagoId
          ? factura.formaDePagoTexto || "Sin descripción"
          : "Sin forma de pago"
      );
      metodosPago.set(
        factura.metodoPago ? String(factura.metodoPago) : SIN_DATO,
        factura.metodoPago === 1
          ? "PUE - Pago en una sola exhibición"
          : factura.metodoPago === 2
          ? "PPD - Pago en parcialidades o diferido"
          : "Sin método de pago"
      );
    });

    const aOpciones = (mapa) =>
      Array.from(mapa, ([id, etiqueta]) => ({ id, etiqueta })).sort((a, b) => {
        if (a.id === SIN_DATO) return 1;
        if (b.id === SIN_DATO) return -1;
        return a.etiqueta.localeCompare(b.etiqueta);
      });

    return {
      proveedores: aOpciones(proveedores),
      formasDePago: aOpciones(formasDePago),
      metodosPago: aOpciones(metodosPago),
    };
  }

  resumenFacturas() {
    const facturas = this.state.facturasCajaChica || [];
    let visibles = 0;
    let saldoFiltrado = 0;
    facturas.forEach((factura) => {
      if (!this.pasaFiltro(factura)) return;
      visibles += 1;
      saldoFiltrado += factura.saldoPendiente > 0 ? factura.saldoPendiente : 0;
    });
    return {
      visibles,
      total: facturas.length,
      saldoFiltrado: round2Decimals(saldoFiltrado),
    };
  }

  //Solo llena las facturas que pasan el filtro; las demas conservan lo que ya tenian.
  setMaxPagarTodos = () => {
    const form = this.formRef.current;
    if (!form) return;
    const facturas = form.getFieldValue("facturas") || [];
    const nuevas = facturas.map((value, index) => {
      const factura = this.state.facturasCajaChica?.[index];
      if (!this.pasaFiltro(factura)) return value;
      const saldoPendiente = factura?.saldoPendiente || 0;
      return {
        ...value,
        cantidadPagar: saldoPendiente > 0 ? saldoPendiente : null,
      };
    });
    form.setFieldsValue({ facturas: nuevas });
  };

  cerrarModalVerReposicion() {
    this.setState({ modalVerReposicion: false, modalVerReposicionId: null });
    this.props.history.push("/panel/cajaefectivo");
  }

  getFacturasColumns() {
    return [
      { title: "Código", width: "9%" },
      { title: "Fecha", width: "8%" },
      { title: "Proyecto", width: "12%" },
      { title: "Proveedor", width: "13%" },
      { title: "Forma de Pago", width: "11%" },
      { title: "Método", width: "6%" },
      { title: "Total a Pagar MXN", width: "10%" },
      { title: "Total Pagado MXN", width: "10%" },
      { title: "Saldo Pendiente MXN", width: "9%" },
      {
        title: (
          <>
            Cantidad a Pagar MXN
            <Tooltip
              title={
                this.hayFiltroActivo()
                  ? "Poner máximos a lo filtrado"
                  : "Poner máximos"
              }
            >
              <CalculatorOutlined
                onClick={this.setMaxPagarTodos}
                style={{ marginLeft: 5, color: "green", cursor: "pointer" }}
              />
            </Tooltip>
          </>
        ),
        width: "12%",
      },
    ];
  }

  renderFiltrosFacturas() {
    const { proveedores, formasDePago, metodosPago } = this.opcionesFiltros();
    const { visibles, total, saldoFiltrado } = this.resumenFacturas();
    const filtroActivo = this.hayFiltroActivo();

    const opcionesA = (opciones) =>
      opciones.map((opcion) => (
        <Option value={opcion.id} key={opcion.id}>
          {opcion.etiqueta}
        </Option>
      ));

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 6,
          marginRight: "auto",
        }}
      >
        <FilterOutlined style={{ color: "#00BFD6" }} />
        <SelectItem
          mode="multiple"
          allowClear
          maxTagCount="responsive"
          width={190}
          placeholder="Proveedor"
          value={this.state.filtroProveedores}
          onChange={(value) =>
            this.setState({ filtroProveedores: value || [] })
          }
        >
          {opcionesA(proveedores)}
        </SelectItem>
        <SelectItem
          mode="multiple"
          allowClear
          maxTagCount="responsive"
          width={190}
          placeholder="Forma de Pago"
          value={this.state.filtroFormasDePago}
          onChange={(value) =>
            this.setState({ filtroFormasDePago: value || [] })
          }
        >
          {opcionesA(formasDePago)}
        </SelectItem>
        <SelectItem
          mode="multiple"
          allowClear
          maxTagCount="responsive"
          width={170}
          placeholder="Método de Pago"
          value={this.state.filtroMetodosPago}
          onChange={(value) =>
            this.setState({ filtroMetodosPago: value || [] })
          }
        >
          {opcionesA(metodosPago)}
        </SelectItem>
        <span style={{ fontSize: 12, color: "#555", whiteSpace: "nowrap" }}>
          {`${visibles} de ${total}`}
        </span>
        <Tag
          color="#00c1d61b"
          style={{
            fontSize: 12,
            border: "1px solid #00BFD6",
            borderRadius: 6,
            fontWeight: 600,
            color: "#026b77",
            marginRight: 0,
          }}
        >
          {`${
            filtroActivo ? "Saldo filtrado" : "Saldo pendiente"
          }: ${dineroDisabledMask(saldoFiltrado)}`}
        </Tag>
      </div>
    );
  }

  renderFacturaRow({ key, name, fieldKey, restField, arrayKey }) {
    const factura = this.state.facturasCajaChica[arrayKey];
    //Las filas que no pasan el filtro se ESCONDEN, no se desmontan: el `arrayKey`
    //del Form.List, las cantidades ya capturadas y la validacion `max` del
    //FormItem dependen de que el renglon siga montado.
    const oculta = !this.pasaFiltro(factura);
    return (
      <tr key={key} style={oculta ? { display: "none" } : undefined}>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, fontWeight: 600, color: "#1a3a4a" }}>
            {factura.codigoFactura}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#555" }}>
            {/* `moment(undefined)` es la fecha de HOY: sin la guarda, un renglon sin
            fecha de factura pinta la fecha de captura como si fuera la de la factura. */}
            {factura.fechaFactura
              ? moment(factura.fechaFactura).format("L")
              : "Sin fecha"}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#555" }}>
            {factura.proyectoNombre}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#555" }}>
            {factura.proveedorNombre}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#555" }}>
            {factura.formaDePagoTexto}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#555" }}>
            {this.textoMetodoPago(factura.metodoPago)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(factura.totalPagar * factura.tipoDeCambio)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(
              factura.totalPagadoCajaChica * factura.tipoDeCambio
            )}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: "#ee3b3e", fontWeight: 600 }}>
            {dineroDisabledMask(factura.saldoPendiente)}
          </p>
        </td>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const facturas = getFieldValue("facturas");
              const cantidadPagar = facturas?.[arrayKey]?.cantidadPagar || 0;
              const esTotal =
                cantidadPagar > 0 && cantidadPagar === factura.saldoPendiente;
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Checkbox
                      className="checkbox-cyan"
                      checked={esTotal}
                      onChange={(e) => {
                        const facturasVal =
                          this.formRef.current.getFieldValue("facturas");
                        facturasVal[arrayKey].cantidadPagar = e.target.checked
                          ? factura.saldoPendiente
                          : null;
                        this.formRef.current.setFieldsValue({
                          facturas: facturasVal,
                        });
                      }}
                    >
                      <span style={{ fontSize: 12, fontWeight: 600 }}>
                        Asignar total
                      </span>
                    </Checkbox>
                  </div>
                  <div className={esTotal ? "cantidad-pagar-total" : ""}>
                    <FormItem
                      {...restField}
                      name={[name, "cantidadPagar"]}
                      fieldKey={[arrayKey, "cantidadPagar"]}
                      noStyle
                      numberCero
                      type="number"
                      max={factura.saldoPendiente}
                    >
                      <InputNumberItem
                        style={{ width: "100%" }}
                        placeholder={"Max: " + factura.saldoPendiente}
                        dinero
                        size="small"
                      />
                    </FormItem>
                  </div>
                </div>
              );
            }}
          </FormItem>
        </td>
      </tr>
    );
  }

  render() {
    const { modoSaldar } = this.state;
    const nombreCaja = this.props.location.state.nombre;

    return (
      <>
        <style>{`
          .cantidad-pagar-total .ant-input-number-input {
            font-weight: 700 !important;
          }
        `}</style>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            (modoSaldar ? "Saldar Caja : " : "Reponer Caja : ") + nombreCaja
          }
          extra={[
            <Tag
              key="saldoActualCaja"
              color="#00c1d61b"
              style={{
                fontSize: 13,
                border: "1px solid #00BFD6",
                padding: "4px 10px",
                borderRadius: 6,
                fontWeight: 600,
                color: "#026b77",
              }}
            >
              Saldo actual: {dineroDisabledMask(this.state.saldoActualCaja)}
            </Tag>,
          ]}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="reponerCaja"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row gutter={[16, 16]}>
                <DynamicCardForm
                  title={<span>PAGO</span>}
                  span={8}
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={8}
                >
                  <FormItem
                    label="Fecha de Pago"
                    name="fechaPago"
                    required
                    margin
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Pago"
                      allowClear={false}
                    />
                  </FormItem>
                  <FormItem label="Proyecto" name="proyectoId" margin required
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                  >
                    <SelectItem placeholder="Proyecto">
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                  <FormItem
                    name="referencia"
                    label="Referencia"
                    margin
                    pattern
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                  >
                    <InputItem placeholder="Referencia" />
                  </FormItem>
                </DynamicCardForm>

                {!modoSaldar && (
                  <DynamicCardForm
                    title={
                      <span>
                        <BankOutlined style={{ color: "#00BFD6", marginRight: 6 }} />
                        BANCO&nbsp;&nbsp;:&nbsp;&nbsp;{nombreCaja}
                      </span>
                    }
                    span={16}
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={16}
                  >
                    <Row>
                      <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                        <FormItem
                          label="Banco"
                          name="bancoId"
                          margin
                          required
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SelectItem placeholder="Banco">
                            {this.state.objetoBancos}
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem
                          label="Cheque"
                          name="cheque"
                          margin
                          labelCol={{ span: 14 }}
                          wrapperCol={{ span: 4 }}
                          valuePropName="checked"
                          initialValue={this.props.location.state.cheque}
                        >
                          <Checkbox />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const cheque = getFieldValue("cheque");
                            const bancoId = getFieldValue("bancoId");
                            if (cheque && bancoId && this.state.todasBancos) {
                              const banco = this.state.todasBancos.find(
                                (b) => b._id.toString() === bancoId.toString()
                              );
                              const consecutivo =
                                banco?.consecutivoCheque || 1;
                              return (
                                <div style={{ textAlign: "center" }}>
                                  <Tag
                                    color="#00c1d61b"
                                    style={{
                                      fontSize: 13,
                                      border: "1px solid #00BFD6",
                                      padding: "4px 10px",
                                      borderRadius: 6,
                                      fontWeight: 600,
                                      color: "#026b77",
                                    }}
                                  >
                                    N° Cheque: {consecutivo}
                                  </Tag>
                                </div>
                              );
                            }
                            return null;
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </DynamicCardForm>
                )}
              </Row>

              <div style={{ marginTop: 24, marginBottom: 50 }}>
                <TabbedDynamicTable
                  tabs={[
                    {
                      key: "facturas",
                      label: "Facturas Caja Chica",
                      listName: "facturas",
                      hideTableWhenEmpty: false,
                      columns: this.getFacturasColumns(),
                      renderHeader: () => this.renderFiltrosFacturas(),
                      renderRow: (rowProps) => this.renderFacturaRow(rowProps),
                    },
                    {
                      key: "traspaso",
                      label: "Traspaso a Caja Chica",
                      customContent: (
                        <Row gutter={16}>
                          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem
                              label="Caja Chica Destino"
                              name="traspasoCajaDestinoId"
                              margin
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 14 }}
                            >
                              <SelectItem placeholder="Caja Chica Destino" allowClear>
                                {this.state.objetoCajaChicaDestino}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem
                              label="Monto a Traspasar"
                              name="traspasoMonto"
                              margin
                              type="number"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 14 }}
                            >
                              <InputNumberItem
                                placeholder="Monto a Traspasar"
                                dinero
                                style={{ width: "100%" }}
                              />
                            </FormItem>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: -8 }}>
                              <ButtonItem
                                size="small"
                                onClick={this.llenarSaldoRestante.bind(this)}
                              >
                                Llenar con saldo restante
                              </ButtonItem>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                  ]}
                />
              </div>

              <Row justify="end" style={{ marginTop: 32, marginBottom: 16 }}>
                <Col xs={24} sm={16} md={10} lg={10} xl={8}>
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const facturas = getFieldValue("facturas");
                      if (!facturas) return null;
                      //`total` no cambia con el filtro: es lo que realmente se manda.
                      let total = 0;
                      let totalFiltrado = 0;
                      let fueraDelFiltroMonto = 0;
                      let fueraDelFiltroCount = 0;
                      facturas.forEach((value, index) => {
                        const cantidad = value?.cantidadPagar
                          ? value.cantidadPagar
                          : 0;
                        total += cantidad;
                        if (
                          this.pasaFiltro(
                            this.state.facturasCajaChica?.[index]
                          )
                        ) {
                          totalFiltrado += cantidad;
                        } else if (cantidad > 0) {
                          fueraDelFiltroMonto += cantidad;
                          fueraDelFiltroCount += 1;
                        }
                      });
                      const filtroActivo = this.hayFiltroActivo();
                      return (
                        <DynamicCardForm
                          span={24}
                          noMargin
                          bodyStyle={{
                            padding: "12px 16px",
                            borderLeft: "4px solid #FF6A0D",
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                          }}
                        >
                          <table
                            className="table"
                            style={{ width: "100%", margin: 0 }}
                          >
                            <tbody>
                              {filtroActivo && (
                                <tr>
                                  <th
                                    className="th-totales"
                                    style={{ fontSize: 14 }}
                                  >
                                    Subtotal filtrado:
                                  </th>
                                  <td
                                    className="td-totales-right"
                                    style={{ fontSize: 14 }}
                                  >
                                    {dineroDisabledMask(
                                      round2Decimals(totalFiltrado)
                                    )}
                                  </td>
                                </tr>
                              )}
                              {fueraDelFiltroCount > 0 && (
                                <tr>
                                  <th
                                    className="th-totales"
                                    style={{
                                      fontSize: 13,
                                      color: "#d46b08",
                                      fontWeight: 600,
                                    }}
                                  >
                                    <WarningOutlined
                                      style={{ marginRight: 4 }}
                                    />
                                    {`${fueraDelFiltroCount} factura${
                                      fueraDelFiltroCount === 1 ? "" : "s"
                                    } fuera del filtro con monto:`}
                                  </th>
                                  <td
                                    className="td-totales-right"
                                    style={{
                                      fontSize: 13,
                                      color: "#d46b08",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {dineroDisabledMask(
                                      round2Decimals(fueraDelFiltroMonto)
                                    )}
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <th
                                  className="th-totales"
                                  style={{ fontSize: 17, fontWeight: 700 }}
                                >
                                  Total a pagar:
                                </th>
                                <td
                                  className="td-totales-right"
                                  style={{ fontSize: 18, fontWeight: 700 }}
                                >
                                  {dineroDisabledMask(total)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </DynamicCardForm>
                      );
                    }}
                  </FormItem>
                </Col>
              </Row>

              <div className="general-form-action-buttons-wrapper">
                <div className="general-form-action-buttons">
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    hotkey="alt+P"
                  >
                    {modoSaldar ? "Saldar" : "Pagar"}
                  </ButtonItem>
                </div>
              </div>
            </Form>
          </Spin>
        </div>
        <VerReposicionCajaChica
          history={this.props.history}
          visible={this.state.modalVerReposicion}
          id={this.state.modalVerReposicionId}
          cerrarVerReposicionCajaChica={this.cerrarModalVerReposicion.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReponerCajaChica);
